import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function HomePage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  // Handle scroll for navbar
  if (typeof window !== 'undefined') {
    window.addEventListener('scroll', () => {
      setIsScrolled(window.scrollY > 50);
    });
  }

  return (
    <div className="min-h-screen bg-white font-['Inter',sans-serif]">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <img src="https://public.readdy.ai/ai/img_res/4dca5efb-d82b-43e8-b16e-b6a2550e513c.png" alt="NAISS EKO-LINE DOO Logo" className="h-12 w-auto" />
              <span className={`text-xl font-bold ${isScrolled ? 'text-gray-900' : 'text-white'}`}>NAISS EKO-LINE</span>
            </div>
            
            <div className="hidden md:flex items-center gap-8">
              <a href="#features" className={`text-sm font-medium transition-colors ${isScrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white/90 hover:text-white'}`}>Features</a>
              <a href="#how-it-works" className={`text-sm font-medium transition-colors ${isScrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white/90 hover:text-white'}`}>How It Works</a>
              <a href="#security" className={`text-sm font-medium transition-colors ${isScrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white/90 hover:text-white'}`}>Security</a>
              <a href="#pricing" className={`text-sm font-medium transition-colors ${isScrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white/90 hover:text-white'}`}>Pricing</a>
              <a href="#contact" className={`text-sm font-medium transition-colors ${isScrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white/90 hover:text-white'}`}>Contact</a>
              <a href="#pricing" className="bg-teal-500 text-white px-6 py-2.5 rounded-full text-sm font-semibold hover:bg-teal-600 transition-colors whitespace-nowrap cursor-pointer">Get Started</a>
            </div>

            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden cursor-pointer">
              <i className={`ri-menu-line text-2xl ${isScrolled ? 'text-gray-900' : 'text-white'}`}></i>
            </button>
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div className="md:hidden mt-4 pb-4 bg-white rounded-lg shadow-lg">
              <div className="flex flex-col gap-4 p-4">
                <a href="#features" className="text-sm font-medium text-gray-700 hover:text-gray-900">Features</a>
                <a href="#how-it-works" className="text-sm font-medium text-gray-700 hover:text-gray-900">How It Works</a>
                <a href="#security" className="text-sm font-medium text-gray-700 hover:text-gray-900">Security</a>
                <a href="#pricing" className="text-sm font-medium text-gray-700 hover:text-gray-900">Pricing</a>
                <a href="#contact" className="text-sm font-medium text-gray-700 hover:text-gray-900">Contact</a>
                <a href="#pricing" className="bg-teal-500 text-white px-6 py-2.5 rounded-full text-sm font-semibold hover:bg-teal-600 transition-colors text-center whitespace-nowrap cursor-pointer">Get Started</a>
              </div>
            </div>
          )}
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://public.readdy.ai/ai/img_res/4e1655b886be4f2f9287e324bec20087.jpg" 
            alt="Digital Network Background" 
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 w-full">
          <div className="flex flex-col md:flex-row items-center justify-between gap-12">
            <div className="md:w-1/2">
              <h1 className="text-6xl md:text-7xl font-bold text-white mb-6 leading-tight">
                secure your<br />digital life
              </h1>
            </div>

            <div className="md:w-1/2 flex flex-col items-end">
              <p className="text-xl text-white/90 mb-4 text-right max-w-md leading-relaxed">
                Experience true online freedom with military-grade encryption
              </p>
              <p className="text-xl text-white/90 mb-8 text-right max-w-md leading-relaxed">
                Browse anonymously from anywhere in the world
              </p>
              <a href="#pricing" className="group flex items-center gap-4 bg-white text-black px-8 py-4 rounded-full text-lg font-semibold hover:bg-gray-100 transition-all cursor-pointer whitespace-nowrap">
                <span>Get Protected Now</span>
                <div className="w-10 h-10 flex items-center justify-center bg-black rounded-full">
                  <i className="ri-arrow-right-line text-white text-xl"></i>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="py-24 bg-[#F8F6F3]">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-5xl md:text-6xl font-serif text-center text-[#2A2A2A] mb-20">Why Choose Our VPN</h2>

          <div className="grid md:grid-cols-3 gap-10">
            {/* Speed Card */}
            <div className="bg-[#1A1A1A] rounded-3xl p-8 shadow-lg">
              <div className="w-16 h-16 flex items-center justify-center bg-gray-800 rounded-full mb-6">
                <i className="ri-flashlight-line text-white text-3xl"></i>
              </div>
              <h3 className="text-4xl font-bold text-white mb-4">Lightning Fast Connections</h3>
              <p className="text-sm text-gray-400">No bandwidth throttling or speed limits</p>
            </div>

            {/* Security Card */}
            <div className="relative rounded-3xl overflow-hidden shadow-lg">
              <img 
                src="https://readdy.ai/api/search-image?query=Abstract%20lock%20and%20shield%20security%20visualization%20with%20encrypted%20data%20patterns%2C%20cybersecurity%20concept%20with%20digital%20protection%20symbols%2C%20dark%20background%20with%20glowing%20security%20elements%2C%20modern%20tech%20security%20illustration%2C%20minimalist%20design%20with%20encryption%20theme&width=400&height=420&seq=security-card-001&orientation=portrait" 
                alt="Security" 
                className="w-full h-full object-cover object-top absolute inset-0"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>
              <div className="relative z-10 p-8 h-full flex flex-col justify-between min-h-[420px]">
                <div className="inline-flex items-center gap-2 bg-black/40 backdrop-blur-sm px-4 py-2 rounded-full self-start">
                  <i className="ri-shield-check-line text-white text-lg"></i>
                  <span className="text-white text-sm font-medium">Military-Grade</span>
                </div>
                <h3 className="text-4xl font-bold text-white">256-bit AES Encryption</h3>
              </div>
            </div>

            {/* Global Coverage Card */}
            <div className="bg-white rounded-3xl p-8 shadow-lg border border-gray-200">
              <h3 className="text-5xl font-serif text-[#2A2A2A] mb-3">150+ Server Locations</h3>
              <p className="text-sm text-gray-500 mb-8">Worldwide coverage across 60 countries</p>
              <div className="relative h-48">
                <img 
                  src="https://readdy.ai/api/search-image?query=World%20map%20visualization%20with%20glowing%20connection%20points%20in%20coral%20orange%20color%2C%20global%20network%20coverage%20illustration%2C%20minimalist%20world%20map%20with%20server%20location%20markers%2C%20clean%20tech%20map%20design%20with%20connectivity%20nodes%2C%20modern%20geographic%20network%20display&width=400&height=240&seq=world-map-001&orientation=landscape" 
                  alt="Global Coverage" 
                  className="w-full h-full object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section id="how-it-works" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-5xl font-serif text-[#2A2A2A] mb-16">Get Started in Three Simple Steps</h2>

          <div className="flex flex-col md:flex-row items-start justify-between gap-8 relative">
            {/* Step 1 */}
            <div className="flex-1 bg-white rounded-2xl border border-gray-200 p-8 relative">
              <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-br from-blue-500 to-purple-600 rounded-full mb-6">
                <span className="text-white text-4xl font-bold">1</span>
              </div>
              <div className="h-32 flex items-center justify-center mb-6">
                <i className="ri-download-cloud-line text-gray-300 text-8xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">Download App</h3>
              <p className="text-base text-gray-600 leading-relaxed">Get our VPN application for your device from our official website or app store</p>
            </div>

            {/* Arrow */}
            <div className="hidden md:flex items-center justify-center pt-10">
              <i className="ri-arrow-right-line text-gray-300 text-4xl"></i>
            </div>

            {/* Step 2 */}
            <div className="flex-1 bg-white rounded-2xl border border-gray-200 p-8 relative">
              <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-br from-blue-500 to-purple-600 rounded-full mb-6">
                <span className="text-white text-4xl font-bold">2</span>
              </div>
              <div className="h-32 flex items-center justify-center mb-6">
                <i className="ri-user-add-line text-gray-300 text-8xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">Create Account</h3>
              <p className="text-base text-gray-600 leading-relaxed">Sign up with your email and choose the plan that fits your needs</p>
            </div>

            {/* Arrow */}
            <div className="hidden md:flex items-center justify-center pt-10">
              <i className="ri-arrow-right-line text-gray-300 text-4xl"></i>
            </div>

            {/* Step 3 */}
            <div className="flex-1 bg-white rounded-2xl border border-gray-200 p-8 relative">
              <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-br from-blue-500 to-purple-600 rounded-full mb-6">
                <span className="text-white text-4xl font-bold">3</span>
              </div>
              <div className="h-32 flex items-center justify-center mb-6">
                <i className="ri-shield-check-line text-gray-300 text-8xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">Connect Securely</h3>
              <p className="text-base text-gray-600 leading-relaxed">Choose your server location and enjoy secure, private browsing instantly</p>
            </div>
          </div>
        </div>
      </section>

      {/* Security & Privacy Section */}
      <section id="security" className="py-24 bg-[#0A1628]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col md:flex-row items-center gap-16">
            {/* Left Content */}
            <div className="md:w-5/12">
              <p className="text-sm text-white/60 mb-5">(Your Privacy Matters)</p>
              <h2 className="text-6xl font-bold text-white mb-4 leading-tight">Zero-Log Policy</h2>
              <h3 className="text-6xl font-bold text-[#8A9BA8] mb-12 leading-tight">Guaranteed</h3>
              
              <p className="text-lg text-white leading-relaxed mb-10">
                We never track, collect, or store your online activity. Your data remains completely private and anonymous. Independently audited and verified.
              </p>
              
              <p className="text-xl font-bold text-white">
                — Certified by Independent Security Auditors
              </p>

              <div className="flex items-center gap-6 mt-12">
                <button className="w-12 h-12 flex items-center justify-center rounded-full border-2 border-gray-600 hover:border-white transition-colors cursor-pointer">
                  <i className="ri-arrow-left-line text-white text-xl"></i>
                </button>
                <button className="w-12 h-12 flex items-center justify-center rounded-full bg-white hover:bg-gray-100 transition-colors cursor-pointer">
                  <i className="ri-arrow-right-line text-black text-xl"></i>
                </button>
              </div>
            </div>

            {/* Right Visual */}
            <div className="md:w-7/12">
              <div className="relative rounded-[32px] overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=3D%20illustration%20of%20encrypted%20data%20flow%20with%20lock%20symbols%20and%20shield%20elements%2C%20cybersecurity%20visualization%20with%20glowing%20security%20icons%2C%20abstract%20digital%20protection%20concept%20with%20purple%20and%20blue%20gradient%20background%2C%20modern%20tech%20security%20artwork%20with%20encryption%20patterns%2C%20futuristic%20data%20privacy%20illustration&width=800&height=600&seq=security-visual-001&orientation=landscape" 
                  alt="Security Visualization" 
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing & Download Section */}
      <section id="pricing" className="py-24 bg-gradient-to-r from-[#6B46C1] to-[#2563EB]">
        <div className="max-w-5xl mx-auto px-6 text-center">
          <h2 className="text-6xl md:text-7xl font-bold text-white mb-6 leading-tight">
            Ready to Browse<br />Without Limits?
          </h2>
          <p className="text-2xl text-white/90 mb-12">Join thousands protecting their privacy daily</p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mb-8">
            <a href="#contact" className="flex items-center gap-3 bg-black text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-gray-900 transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-smartphone-line text-xl"></i>
              <span>Download for Mobile</span>
            </a>
          </div>

          <div className="flex items-center justify-center gap-4 text-sm text-white/80">
            <a href="#contact" className="hover:text-white transition-colors cursor-pointer">macOS</a>
            <span>•</span>
            <a href="#contact" className="hover:text-white transition-colors cursor-pointer">iOS</a>
          </div>
        </div>
      </section>

      {/* Contact Footer */}
      <footer id="contact" className="bg-black text-white py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="mb-20">
            <h2 className="text-6xl md:text-7xl font-bold mb-4">NAISS EKO-LINE DOO</h2>
          </div>

          <div className="grid md:grid-cols-3 gap-12 mb-16">
            {/* Left Column */}
            <div>
              <p className="text-base leading-relaxed mb-10">
                Protecting your digital freedom with cutting-edge VPN technology. Secure, fast, and reliable connections worldwide.
              </p>
              <div className="flex items-center gap-5">
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full border-2 border-white hover:bg-white hover:text-black transition-colors cursor-pointer">
                  <i className="ri-twitter-line text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full border-2 border-white hover:bg-white hover:text-black transition-colors cursor-pointer">
                  <i className="ri-facebook-line text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full border-2 border-white hover:bg-white hover:text-black transition-colors cursor-pointer">
                  <i className="ri-linkedin-line text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full border-2 border-white hover:bg-white hover:text-black transition-colors cursor-pointer">
                  <i className="ri-instagram-line text-lg"></i>
                </a>
              </div>
            </div>

            {/* Middle Column */}
            <div className="space-y-12">
              <div>
                <h4 className="text-xs font-semibold tracking-widest mb-3 uppercase">Address</h4>
                <p className="text-base leading-relaxed">
                  Mokranjceva 62<br />
                  Nis, 701842<br />
                  Serbia
                </p>
              </div>

              <div>
                <h4 className="text-xs font-semibold tracking-widest mb-3 uppercase">Phone</h4>
                <p className="text-base">+1 9018995166</p>
              </div>

              <div>
                <h4 className="text-xs font-semibold tracking-widest mb-3 uppercase">Email</h4>
                <p className="text-base">contact@naisseko-linedoo.com</p>
              </div>
            </div>

            {/* Right Column */}
            <div className="flex justify-end">
              <div className="w-full md:w-72 h-96 rounded-2xl overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=Abstract%20server%20room%20visualization%20with%20blue%20accent%20lighting%2C%20modern%20data%20center%20infrastructure%20with%20network%20equipment%2C%20futuristic%20tech%20facility%20with%20glowing%20server%20racks%2C%20minimalist%20technology%20environment%20with%20cool%20blue%20illumination%2C%20clean%20digital%20infrastructure%20photography&width=280&height=360&seq=server-room-001&orientation=portrait" 
                  alt="Server Infrastructure" 
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>

          {/* Bottom Copyright */}
          <div className="pt-8 border-t border-white/10">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4">
              <p className="text-sm text-white/70">© 2025 NAISS EKO-LINE DOO. All rights reserved.</p>
              <div className="flex items-center gap-8 text-sm text-white/70">
                <a href="#" className="hover:text-white transition-colors cursor-pointer">Privacy Policy</a>
                <span>•</span>
                <a href="#" className="hover:text-white transition-colors cursor-pointer">Terms of Service</a>
                <span>•</span>
                <a href="#" className="hover:text-white transition-colors cursor-pointer">Security</a>
              </div>
            </div>
          </div>

          {/* Readdy Link */}
          <div className="mt-8 text-center">
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-sm text-white/50 hover:text-white/70 transition-colors cursor-pointer">
              Website Builder
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}
